import React, { useState, useEffect } from 'react';
import { Modal } from '@getpingback/realeza';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Button, TextField } from '@material-ui/core';

const UpdateContactBulkActionModal = ({ isOpen, onClose, onSubmit, isUpdating, dataForm }) => {
  const [formValues, setFormValues] = useState({
    id: dataForm ? dataForm.id : null,
    status: '',
  });

  useEffect(() => {
    if (dataForm && isUpdating) {
      setFormValues({
        id: dataForm.id,
        status: dataForm.status,
      });
    }
  }, [dataForm]);

  return (
    <Modal onClose={onClose} isOpen={isOpen} className="saasPlans__modal">
      <div className="saasPlans__modal__top">
        <h2>{isUpdating ? 'Update Contact Bulk Action' : 'New Contact Bulk Action'}</h2>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <div className="saasPlans__modal__content">
        <div>
          <TextField
            id="standard-basic"
            label="Status"
            value={formValues.status}
            onChange={e => setFormValues({ ...formValues, status: e.target.value })}
            required
            variant="outlined"
          />
        </div>

        <Button
          style={{ margin: '20px', backgroundColor: '#249c0d', color: '#fff' }}
          variant="contained"
          onClick={() => onSubmit(formValues)}
        >
          {isUpdating ? 'Update' : 'Save'}
        </Button>
      </div>
    </Modal>
  );
};

export default UpdateContactBulkActionModal;
